import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import UploadWorkSubtitle from 'components/arena/UploadWorkSubtitle';

import { gettext } from '../../utils/text';
import Input from '../inputs/Input';
import TextArea from '../inputs/TextArea';
import Select from '../inputs/Select';
import { ErrorsShape, SelectOptionsShape } from '../../utils/shapes';
import TrafoTextPreview from './TrafoTextPreview';

const UploadWorkText = (props) => (
    <div className="upload-work__text">
        {props.previewingText && (
            <TrafoTextPreview
                className={props.previewingText ? 'mb-5' : 'mb-5 d-none'}
                title={props.values.title}
                text={props.values.text}
                align={props.values.text_align}
                font={props.values.text_font}
                lineHeight={props.values.text_lineheight}
            />
        )}
        <div className={classNames('upload-work__text__form', { 'd-none': props.previewingText })}>
            <Input
                name="title"
                label={gettext('Title')}
                placeholder={gettext('Add title')}
                value={props.values.title}
                error={props.errors.title}
                onChange={props.handleChange}
                required
            />
            <TextArea
                className="form-group--huge"
                name="text"
                label={gettext('Text')}
                placeholder={gettext('Text')}
                value={props.values.text}
                error={props.errors.text}
                onChange={props.handleChange}
                required
            />
            <TextArea
                name="comment"
                label={gettext('Description')}
                placeholder={gettext('Insert work description that will be displayed under the work')}
                value={props.values.comment}
                error={props.errors.comment}
                onChange={props.handleChange}
            />
        </div>
        <div className="form-row align-items-end">
            <Select
                className="col-12 col-md-4 col-lg-12 col-xxl-4"
                name="text_align"
                label={gettext('Select text alignment')}
                options={props.textAlignOptions}
                value={props.values.text_align}
                error={props.errors.text_align}
                onChange={props.handleChange}
            />
            <Select
                className="col-12 col-md-4 col-lg-12 col-xxl-4"
                name="text_font"
                label={gettext('Select font')}
                options={props.textFontOptions}
                value={props.values.text_font}
                error={props.errors.text_font}
                onChange={props.handleChange}
            />
            <Select
                className="col-12 col-md-4 col-lg-12 col-xxl-4"
                name="text_lineheight"
                label={gettext('Select line height')}
                options={props.textLineheightOptions}
                value={props.values.text_lineheight}
                error={props.errors.text_lineheight}
                onChange={props.handleChange}
            />
            <input name="access" value={1} readOnly hidden />
        </div>

        <UploadWorkSubtitle withSubtitle={props.withSubtitle} />
        <button className="btn btn-dark btn-text-light mt-4" type="button" onClick={props.toggleTextPreview}>
            {props.previewingText ? gettext('Edit') : gettext('Preview')}
        </button>
    </div>
);

UploadWorkText.propTypes = {
    textAlignOptions: SelectOptionsShape,
    textFontOptions: SelectOptionsShape,
    textLineheightOptions: SelectOptionsShape,
    values: PropTypes.shape({
        title: PropTypes.string,
        comment: PropTypes.string,
        text: PropTypes.string,
        text_align: PropTypes.string,
        text_font: PropTypes.string,
        text_lineheight: PropTypes.string,
    }).isRequired,
    errors: ErrorsShape,
    previewingText: PropTypes.bool,
    withSubtitle: PropTypes.bool,
    handleChange: PropTypes.func,
    toggleTextPreview: PropTypes.func,
};

UploadWorkText.defaultProps = {
    textAlignOptions: [],
    textFontOptions: [],
    textLineheightOptions: [],
    errors: {},
    previewingText: false,
    withSubtitle: true,
    handleChange: undefined,
    toggleTextPreview: undefined,
};

export default UploadWorkText;



// WEBPACK FOOTER //
// ./src/components/arena/UploadWorkText.js